module.exports = __webpack_public_path__ + "static/img/智能仓储2.48979db8.jpg";